export default "__VITE_ASSET__D1jxUpH1__"